import { useUserEventLogger } from '@repo/tracking-service';
import { useRouter } from 'next/router';

import { OngoingRefundButton } from '@/components/my/common/OngoingRefundButton';
import { COMMON_PATHS } from '@/lib/constants/paths';

export const OngoingRefund = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const goRefundSummaryPage = () => {
    sendClickEvent('history_body_ongoing-list');
    router.push(COMMON_PATHS.환급조회목록);
  };

  return <OngoingRefundButton onClick={goRefundSummaryPage} />;
};
